import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { MediumHeader } from '@narvar/nth-header';
import TextArea from '@narvar/nth-text-area';
import Button from '@narvar/nth-button';
import { Container, Row, Column } from '@narvar/nth-grid';
import ButtonGroup from '../ButtonGroup';

const mapStateToProps = ({ language }) => ({
  language,
});

const TextAreaContainer = styled.div`
  margin: 1rem auto;
  position: relative;
  label {
    font-weight: 400;
  }
`;

// Temporary
const DEFAULT_OPTIONS = [
  {
    id: 'unattended',
    label: 'Contactless',
    selected: false,
  },
  {
    id: 'handoff',
    label: 'Direct Handoff',
    selected: false,
  },
  {
    id: 'front desk',
    label: 'At Front Desk',
    selected: false,
  },
];

const PickupDetailsForm = ({ language, instructionsCharLimit }) => {
  const [instructions, setInstructions] = React.useState('');
  const [options, setOptions] = React.useState(DEFAULT_OPTIONS);

  return (
    <Container style={{ border: '1px solid #cccccc', borderRadius: '4px', textAlign: 'center' }}>
      <Row>
        <Column sm-column-offset={1} sm-columns={10}>
          <MediumHeader>{language['returns.home_pickup.details_form.title']}</MediumHeader>
          <div style={{ margin: '1rem auto' }}>
            {language['returns.home_pickup.details_form.pickup_types.title']}
          </div>
          <div>
            <ButtonGroup
              options={options}
              onClick={({ id }) => {
                const updatedOptions = options.map((option) => ({
                  ...option,
                  selected: option.id === id,
                }));
                setOptions(updatedOptions);
              }}
            />
          </div>
          <div style={{ margin: '1rem auto' }}>
            {language['returns.home_pickup.details_form.instructions.title']}
          </div>
          <TextAreaContainer>
            <TextArea
              id="pickupInstructions"
              name="pickupInstructions"
              label={language['returns.home_pickup.details_form.instructions.placeholder']}
              labelStyle={{ fontWeight: 300 }}
              value={instructions}
              onChange={({ target: { value } }) => setInstructions(value)}
              maxLength={instructionsCharLimit}
              inputStyle={{
                resize: 'none',
                borderColor: '#cccccc',
              }}
            />
            <span
              style={{
                position: 'absolute',
                bottom: '0.7rem',
                right: '0.5rem',
                fontSize: '10px',
                fontWeight: 500,
                color: '#767676',
              }}
            >
              {`${instructions.length}/${instructionsCharLimit}`}
            </span>
          </TextAreaContainer>
          <div style={{ marginBottom: '1.5rem' }}>
            <Button big className="narvar-btn-primary">
              {language['returns.home_pickup.details_form.submit']}
            </Button>
          </div>
        </Column>
      </Row>
    </Container>
  );
};

PickupDetailsForm.defaultProps = {
  instructionsCharLimit: 85,
};

PickupDetailsForm.propTypes = {
  language: PropTypes.object.isRequired,
  instructionsCharLimit: PropTypes.number,
};

export default connect(mapStateToProps)(PickupDetailsForm);
